export interface MessagePart<T> {
  type: MessagePartType;
  message: string;
  payload?: T;
}

interface LinkedMessage {
  type: LinkedMessageType;
  messageId: string;
}

export enum LinkedMessageType {
  Forward,
  Reply,
  // etc...
}

export enum MessagePartType {
  Text,
  Image,
  Audio,
  Video,
  Sticker,
  Emoji,
}

export interface Message<P = any> {
  id: string;
  groupId: string;
  createdBy: string;
  parts: MessagePart<P>[];
  linkedMessages: LinkedMessage[];
  usersReceived: string[];
  usersRead: string[];
  createdAt: string;
  updatedAt: string;
}
